import React from "react";

export default function SessionHistory({ history }) {
  return (
    <section className="history-panel info-panel">
      <div className="section-kicker">Recent prompts</div>
      <h2>Local session trail</h2>
      <ul>
        {history.length === 0 ? (
          <li className="history-empty">No local history yet.</li>
        ) : (
          history.map((item) => (
            <li key={item.id}>
              <strong>{item.question}</strong>
              <span>
                {typeof item.attachmentCount === "number"
                  ? `${item.attachmentCount} files`
                  : "No files"}
              </span>
            </li>
          ))
        )}
      </ul>
    </section>
  );
}
